// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Tutorial2.css  —  KinetiQ CRE Course Notes Page — Lecture 2
   Font system: Inter throughout — identical tokens, sizes,
   weights & letter-spacing to TutorialsDashboard.css & Tutorial1.css
   ============================================================ */

   /* ─── Design tokens — mirrored from TutorialsDashboard.css ──── */
   :root {
     /* Backgrounds & surfaces */
     --t2-bg:              #f7f9fa;
     --t2-surface:         #ffffff;
     --t2-panel:           #f3f4f6;
     --t2-card:            #ffffff;
     --t2-sidebar-bg:      #f0f2f4;
     --t2-sidebar-header:  #e8eaed;
     --t2-code-bg:         #f5f7fa;
     --t2-eq-bg:           #fafbfc;
   
     /* Accent — green */
     --t2-accent:          #28a745;
     --t2-accent-dim:      rgba(40, 167, 69, 0.10);
     --t2-accent-glow:     rgba(40, 167, 69, 0.15);
     --t2-accent-hover:    #1e8c3a;
   
     /* Semantic colours */
     --t2-amber:           #b4690e;
     --t2-amber-dim:       rgba(180, 105, 14, 0.08);
     --t2-amber-border:    rgba(180, 105, 14, 0.22);
     --t2-cyan:            #0891b2;
     --t2-cyan-dim:        rgba(8, 145, 178, 0.08);
     --t2-cyan-border:     rgba(8, 145, 178, 0.22);
     --t2-blue:            #2563eb;
     --t2-blue-dim:        rgba(37, 99, 235, 0.08);
     --t2-blue-border:     rgba(37, 99, 235, 0.22);
     --t2-green-dim:       rgba(40, 167, 69, 0.08);
     --t2-green-border:    rgba(40, 167, 69, 0.22);
   
     /* Purple — tdb-purple */
     --t2-purple:          #5624d0;
     --t2-purple-light:    rgba(86, 36, 208, 0.07);
     --t2-purple-border:   rgba(86, 36, 208, 0.18);
   
     /* Reactor type colours */
     --t2-batch:           #b4690e;
     --t2-cstr:            #c0392b;
     --t2-pfr:             #2563eb;
     --t2-pbr:             #28a745;
   
     /* Borders */
     --t2-border:          #d1d7dc;
     --t2-border-light:    #e8ecef;
     --t2-border-mid:      #bbc1c8;
   
     /* Text — tdb-text scale */
     --t2-text:            #1c1d1f;
     --t2-text-muted:      #4a4f5a;
     --t2-text-mid:        #3a3f4a;
     --t2-text-dim:        #6a6f73;
     --t2-text-sub:        #8a8f96;
   
     /* Font — identical to tdb-font & Tutorial1 --t-font */
     --t2-font:            'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
     --t2-font-mono:       'Courier New', 'Courier', monospace;
   
     /* Spacing */
     --t2-space-xs:  6px;
     --t2-space-sm:  10px;
     --t2-space-md:  16px;
     --t2-space-lg:  24px;
     --t2-space-xl:  40px;
     --t2-space-2xl: 56px;
   
     /* Radii — tdb uses 6px (md), 4px (sm) */
     --t2-radius-sm: 4px;
     --t2-radius-md: 6px;
     --t2-radius-lg: 8px;
   
     --t2-sidebar-w: 260px;
   }
   
   /* ─── Reset ─────────────────────────────────────────────────── */
   *,
   *::before,
   *::after {
     box-sizing: border-box;
     margin: 0;
     padding: 0;
   }
   
   /* ─── Scrollbar ─────────────────────────────────────────────── */
   ::-webkit-scrollbar        { width: 5px; height: 5px; }
   ::-webkit-scrollbar-track  { background: transparent; }
   ::-webkit-scrollbar-thumb  { background: var(--t2-border); border-radius: 3px; }
   ::-webkit-scrollbar-thumb:hover { background: var(--t2-border-mid); }
   
   /* ══════════════════════════════════════════════════════════════
      CONTAINER — base Inter 15px / 400 / 1.7 matching TutorialsDashboard
   ══════════════════════════════════════════════════════════════ */
   .cre2-container {
     font-family: var(--t2-font);
     background:  var(--t2-bg);
     color:       var(--t2-text);
     display:     flex;
     height:      100%;
     width:       100%;
     font-size:   15px;
     line-height: 1.7;
     overflow:    hidden;
   }
   
   /* ══════════════════════════════════════════════════════════════
      SIDEBAR
   ══════════════════════════════════════════════════════════════ */
   .cre2-sidebar {
     display:        none;
     width:          var(--t2-sidebar-w);
     min-width:      var(--t2-sidebar-w);
     background:     var(--t2-sidebar-bg);
     border-right:   1px solid var(--t2-border);
     height:         100%;
     overflow-y:     auto;
     padding-bottom: 40px;
     font-size:      13px;
     flex-shrink:    0;
     position:       relative;
   }
   
   @media (min-width: 1600px) {
     .cre2-sidebar { display: block; }
   }
   
   .cre2-sidebar-header {
     background:    var(--t2-sidebar-header);
     padding:       20px 18px 16px;
     border-bottom: 1px solid var(--t2-border);
     position:      sticky;
     top:           0;
     z-index:       10;
   }
   
   /* Matches tdb-header-tag: 13px / 700 / uppercase / 2px tracking / accent */
   .cre2-sidebar-header h1 {
     font-family:    var(--t2-font);
     font-size:      13px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t2-accent);
     margin-bottom:  4px;
   }
   
   /* Matches tdb-card-desc: 14px / 400 / text-muted */
   .cre2-sidebar-header p {
     font-family: var(--t2-font);
     font-size:   14px;
     font-weight: 400;
     color:       var(--t2-text-muted);
   }
   
   /* Matches tdb-card-tag: 12px / 700 / uppercase / 0.8px tracking / purple */
   .cre2-nav-section {
     padding:        14px 0 4px 18px;
     font-family:    var(--t2-font);
     font-size:      12px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 0.8px;
     color:          var(--t2-purple);
     margin-top:     8px;
   }
   
   /* Matches tdb-popup-bullets: 13px / 400 / text-muted */
   .cre2-nav-item {
     display:         block;
     padding:         7px 18px 7px 28px;
     font-family:     var(--t2-font);
     font-size:       13px;
     font-weight:     400;
     color:           var(--t2-text-muted);
     text-decoration: none;
     border-left:     3px solid transparent;
     transition:      all 0.15s;
     line-height:     1.5;
     cursor:          pointer;
   }
   .cre2-nav-item:hover {
     color:             var(--t2-text);
     background:        rgba(40, 167, 69, 0.06);
     border-left-color: var(--t2-accent);
   }
   .cre2-nav-item--sub {
     padding-left: 40px;
     font-size:    12px;
     color:        var(--t2-text-dim);
   }
   
   /* ══════════════════════════════════════════════════════════════
      MAIN CONTENT
   ══════════════════════════════════════════════════════════════ */
   .cre2-main {
     flex:       1 1;
     overflow-y: auto;
     overflow-x: hidden;
     min-width:  0;
     animation:  fadeIn2 0.25s ease;
   }
   
   /* Matches Tutorial1 cre-main-inner padding */
   .cre2-main-inner {
     margin:  0 auto;
     padding: 52px 64px 88px;
   }
   
   /* ─── Hero — matches tdb-header exactly ─────────────────────── */
   .cre2-hero {
     margin-bottom:  var(--t2-space-2xl);
     padding-bottom: 32px;
     border-bottom:  2px solid var(--t2-text);
   }
   
   /* Matches .tdb-header-tag: 13px / 700 / uppercase / 2px tracking / purple */
   .cre2-hero-tag {
     font-family:    var(--t2-font);
     font-size:      13px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t2-purple);
     margin-bottom:  10px;
   }
   
   /* Matches .tdb-header-title: 32px / 800 / -0.5px / 1.2 lh */
   .cre2-hero h1 {
     font-family:    var(--t2-font);
     font-size:      32px;
     font-weight:    800;
     line-height:    1.2;
     letter-spacing: -0.5px;
     margin-bottom:  12px;
     color:          var(--t2-text);
   }
   
   /* Matches .tdb-header-desc: 16px / 400 / 1.7 / text-muted / max-width 640px */
   .cre2-hero-desc {
     font-family: var(--t2-font);
     font-size:   16px;
     font-weight: 400;
     color:       var(--t2-text-muted);
     max-width:   640px;
     line-height: 1.7;
     margin:      0;
   }
   
   .cre2-hero-meta {
     display:    flex;
     gap:        24px;
     margin-top: 20px;
     flex-wrap:  wrap;
   }
   
   /* Matches tdb meta-item: 12px / 400 / text-dim */
   .cre2-meta-item {
     font-family: var(--t2-font);
     font-size:   12px;
     font-weight: 400;
     color:       var(--t2-text-dim);
     display:     flex;
     align-items: center;
     gap:         6px;
   }
   
   .cre2-meta-dot {
     width:         6px;
     height:        6px;
     border-radius: 50%;
     background:    var(--t2-accent);
     display:       inline-block;
     flex-shrink:   0;
   }
   
   /* ─── TOC box ───────────────────────────────────────────────── */
   .cre2-toc-box {
     background:    var(--t2-surface);
     border:        1px solid var(--t2-border);
     border-left:   3px solid var(--t2-accent);
     border-radius: var(--t2-radius-md);
     padding:       22px 26px;
     margin-bottom: 40px;
     box-shadow:    0 2px 8px rgba(0, 0, 0, 0.06);
   }
   
   /* Matches tdb-card-tag: 12px / 700 / uppercase / 0.8px tracking / accent */
   .cre2-toc-box h3 {
     font-family:    var(--t2-font);
     font-size:      12px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 0.8px;
     color:          var(--t2-accent);
     margin-bottom:  14px;
   }
   
   .cre2-toc-grid {
     display:               grid;
     grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
     gap:                   6px 24px;
   }
   
   /* Matches tdb-popup-bullets li: 13px / 400 / blue */
   .cre2-toc-link {
     font-family:     var(--t2-font);
     font-size:       13px;
     font-weight:     400;
     color:           var(--t2-blue);
     text-decoration: none;
     display:         flex;
     align-items:     center;
     padding:         2px 0;
     transition:      color 0.15s;
   }
   .cre2-toc-link:hover { color: var(--t2-accent); }
   
   /* ─── Lecture badge — matches .tdb-badge ────────────────────── */
   /* Matches .tdb-badge: 12px / 700 / uppercase / 0.2px tracking / 3px 9px */
   .cre2-lec-badge {
     display:        inline-block;
     font-family:    var(--t2-font);
     font-size:      12px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 0.2px;
     padding:        3px 9px;
     border-radius:  var(--t2-radius-sm);
     margin-bottom:  14px;
   }
   
   .cre2-lec-badge--review {
     background: rgba(180, 105, 14, 0.08);
     color:      var(--t2-amber);
     border:     1px solid var(--t2-amber-border);
   }
   .cre2-lec-badge--lec2 {
     background: var(--t2-blue-dim);
     color:      var(--t2-blue);
     border:     1px solid var(--t2-blue-border);
   }
   
   /* ─── Section ───────────────────────────────────────────────── */
   .cre2-section {
     margin-bottom:     var(--t2-space-2xl);
     scroll-margin-top: 24px;
   }
   
   /* Matches .tdb-header-tag: 13px / 700 / uppercase / 2px tracking / purple */
   .cre2-section-label {
     font-family:    var(--t2-font);
     font-size:      13px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t2-purple);
     margin-bottom:  8px;
   }
   
   /* Matches tdb section heading: 26px / 800 / -0.3px / 1.25 lh */
   .cre2-section h2 {
     font-family:    var(--t2-font);
     font-size:      26px;
     font-weight:    800;
     letter-spacing: -0.3px;
     color:          var(--t2-text);
     margin-bottom:  6px;
     line-height:    1.25;
   }
   
   .cre2-section-divider {
     width:         40px;
     height:        3px;
     background:    var(--t2-accent);
     margin-bottom: 22px;
     border-radius: 2px;
   }
   
   /* Matches .tdb-card-title: 17px / 700 / -0.1px */
   .cre2-section h3 {
     font-family:    var(--t2-font);
     font-size:      17px;
     font-weight:    700;
     letter-spacing: -0.1px;
     color:          var(--t2-text);
     margin:         28px 0 10px;
   }
   
   /* Matches tdb body copy: 15px / 400 / 1.7 / text-muted */
   .cre2-section p {
     font-family:   var(--t2-font);
     font-size:     15px;
     font-weight:   400;
     margin-bottom: 14px;
     color:         var(--t2-text-muted);
     line-height:   1.7;
   }
   
   /* Matches tdb-popup-bullets: 14px / 400 / 1.65 / text-muted */
   .cre2-section ul,
   .cre2-section ol {
     font-family:   var(--t2-font);
     font-size:     14px;
     font-weight:   400;
     padding-left:  20px;
     margin-bottom: 14px;
     color:         var(--t2-text-muted);
     line-height:   1.65;
   }
   .cre2-section li { margin-bottom: 6px; }
   
   /* ─── Equation box ──────────────────────────────────────────── */
   .cre2-eq-box {
     background:    var(--t2-eq-bg);
     border:        1px solid var(--t2-border);
     border-left:   3px solid var(--t2-amber);
     border-radius: var(--t2-radius-md);
     padding:       18px 22px;
     margin:        18px 0;
     overflow-x:    auto;
   }
   
   /* Matches tdb-card-tag label: 11px / 700 / uppercase / 0.8px */
   .cre2-eq-label {
     font-family:    var(--t2-font);
     font-size:      11px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 0.8px;
     color:          var(--t2-text-dim);
     margin-bottom:  8px;
   }
   
   .cre2-eq-main {
     font-family: var(--t2-font-mono);
     font-size:   14px;
     color:       var(--t2-blue);
     line-height: 2;
     white-space: pre-line;
   }
   
   /* Matches tdb-eq-note: 12px / 400 / 1.6 / text-dim */
   .cre2-eq-note {
     font-family: var(--t2-font);
     font-size:   12px;
     font-weight: 400;
     color:       var(--t2-text-dim);
     margin-top:  8px;
     white-space: pre-line;
     line-height: 1.6;
   }
   
   /* ─── Callout boxes — matches .tdb-popup-desc ───────────────── */
   .cre2-callout {
     border-radius: var(--t2-radius-md);
     padding:       14px 18px;
     margin:        18px 0;
     line-height:   1.65;
   }
   /* Matches .tdb-popup-desc: 14px / 400 / 1.65 / text-muted */
   .cre2-callout p {
     font-family: var(--t2-font);
     font-size:   14px;
     font-weight: 400;
     color:       var(--t2-text-muted);
     margin:      0;
     line-height: 1.65;
   }
   .cre2-callout--key  { background: var(--t2-blue-dim);  border: 1px solid var(--t2-blue-border);  }
   .cre2-callout--warn { background: var(--t2-amber-dim); border: 1px solid var(--t2-amber-border); }
   .cre2-callout--tip  { background: var(--t2-green-dim); border: 1px solid var(--t2-green-border); }
   .cre2-callout--info { background: var(--t2-cyan-dim);  border: 1px solid var(--t2-cyan-border);  }
   
   /* ─── Card grid ─────────────────────────────────────────────── */
   .cre2-card-grid {
     display:               grid;
     grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
     gap:                   14px;
     margin:                20px 0;
   }
   
   .cre2-card {
     background:    var(--t2-surface);
     border:        1px solid var(--t2-border);
     border-radius: var(--t2-radius-md);
     padding:       16px 18px;
     transition:    border-color 0.18s, box-shadow 0.18s, transform 0.18s;
     box-shadow:    0 2px 6px rgba(0, 0, 0, 0.06);
   }
   .cre2-card:hover {
     border-color: var(--t2-accent);
     box-shadow:   0 8px 28px rgba(0, 0, 0, 0.10);
     transform:    translateY(-2px);
   }
   .cre2-card-icon { font-size: 22px; margin-bottom: 8px; }
   
   /* Matches .tdb-card-title: 17px / 700 / -0.1px */
   .cre2-card h4 {
     font-family:    var(--t2-font);
     font-size:      17px;
     font-weight:    700;
     color:          var(--t2-text);
     margin-bottom:  6px;
     letter-spacing: -0.1px;
   }
   /* Matches .tdb-card-desc: 14px / 400 / 1.65 / text-muted */
   .cre2-card p {
     font-family: var(--t2-font);
     font-size:   14px;
     font-weight: 400;
     color:       var(--t2-text-muted);
     margin:      0;
     line-height: 1.65;
   }
   
   /* ─── Steps list ────────────────────────────────────────────── */
   .cre2-steps { margin: 20px 0; }
   
   .cre2-step {
     display:       flex;
     gap:           16px;
     margin-bottom: 20px;
     align-items:   flex-start;
   }
   
   .cre2-step-num {
     min-width:       32px;
     height:          32px;
     background:      var(--t2-accent);
     color:           #fff;
     border-radius:   50%;
     display:         flex;
     align-items:     center;
     justify-content: center;
     font-family:     var(--t2-font);
     font-weight:     700;
     font-size:       13px;
     margin-top:      2px;
     flex-shrink:     0;
     box-shadow:      0 2px 8px var(--t2-accent-glow);
   }
   
   .cre2-step-content { flex: 1 1; }
   /* Matches .tdb-card-title: 17px / 700 / -0.1px */
   .cre2-step-content h4 {
     font-family:    var(--t2-font);
     font-size:      17px;
     font-weight:    700;
     color:          var(--t2-text);
     margin-bottom:  6px;
     letter-spacing: -0.1px;
   }
   /* Matches .tdb-card-desc: 14px / 400 / 1.65 */
   .cre2-step-content p {
     font-family: var(--t2-font);
     font-size:   14px;
     font-weight: 400;
     color:       var(--t2-text-muted);
     margin:      0 0 8px;
     line-height: 1.65;
   }
   
   /* ─── Example box ───────────────────────────────────────────── */
   .cre2-example-box {
     background:    var(--t2-surface);
     border:        1px solid var(--t2-border);
     border-top:    3px solid var(--t2-accent);
     border-radius: var(--t2-radius-md);
     padding:       20px 24px;
     margin:        20px 0;
     box-shadow:    0 2px 6px rgba(0, 0, 0, 0.06);
   }
   
   /* Matches .tdb-badge: 12px / 700 / uppercase / 0.2px tracking */
   .cre2-example-tag {
     font-family:    var(--t2-font);
     font-size:      12px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 0.2px;
     color:          var(--t2-accent);
     margin-bottom:  8px;
   }
   /* Matches .tdb-card-title: 17px / 700 / -0.1px */
   .cre2-example-box h4 {
     font-family:    var(--t2-font);
     font-size:      17px;
     font-weight:    700;
     color:          var(--t2-text);
     margin-bottom:  10px;
     letter-spacing: -0.1px;
   }
   /* Matches .tdb-card-desc: 14px / 400 / 1.65 */
   .cre2-example-box p {
     font-family:   var(--t2-font);
     font-size:     14px;
     font-weight:   400;
     color:         var(--t2-text-muted);
     margin-bottom: 10px;
     line-height:   1.65;
   }
   
   /* ─── Tables ─────────────────────────────────────────────────── */
   .cre2-table {
     width:           100%;
     border-collapse: collapse;
     margin:          20px 0;
     font-family:     var(--t2-font);
     font-size:       13px;
     background:      var(--t2-surface);
     border-radius:   var(--t2-radius-md);
     overflow:        hidden;
     border:          1px solid var(--t2-border);
   }
   .cre2-table thead { background: var(--t2-panel); }
   /* Matches tdb-table th: 11px / 700 / uppercase / 0.8px tracking */
   .cre2-table th {
     padding:        10px 14px;
     text-align:     left;
     font-family:    var(--t2-font);
     font-size:      11px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 0.8px;
     color:          var(--t2-text-muted);
     border-bottom:  1px solid var(--t2-border);
   }
   /* Matches tdb-table td: 13px / 400 / 1.55 / text-muted */
   .cre2-table td {
     font-family:    var(--t2-font);
     font-size:      13px;
     font-weight:    400;
     padding:        10px 14px;
     border-bottom:  1px solid var(--t2-border-light);
     color:          var(--t2-text-muted);
     vertical-align: top;
     line-height:    1.55;
   }
   .cre2-table tr:last-child td { border-bottom: none; }
   .cre2-table tr:hover td { background: rgba(40, 167, 69, 0.03); }
   
   /* ─── Inline code ───────────────────────────────────────────── */
   .cre2-inline-code {
     font-family:   var(--t2-font-mono);
     font-size:     0.88em;
     background:    var(--t2-code-bg);
     color:         var(--t2-blue);
     padding:       2px 6px;
     border-radius: var(--t2-radius-sm);
     border:        1px solid var(--t2-border-light);
   }
   
   /* ─── Reactor type badges — matches .tdb-badge ──────────────── */
   /* Matches .tdb-badge: 12px / 700 / uppercase / 0.2px tracking */
   .cre2-badge {
     display:        inline-block;
     font-family:    var(--t2-font);
     font-size:      12px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 0.2px;
     padding:        3px 9px;
     border-radius:  var(--t2-radius-sm);
     white-space:    nowrap;
   }
   .cre2-badge--batch { background: rgba(180, 105, 14, 0.08); color: var(--t2-batch); border: 1px solid var(--t2-amber-border); }
   .cre2-badge--cstr  { background: rgba(192, 57, 43, 0.08);  color: var(--t2-cstr);  border: 1px solid rgba(192, 57, 43, 0.18); }
   .cre2-badge--pfr   { background: var(--t2-blue-dim);        color: var(--t2-pfr);   border: 1px solid var(--t2-blue-border); }
   .cre2-badge--pbr   { background: var(--t2-green-dim);       color: var(--t2-pbr);   border: 1px solid var(--t2-green-border); }
   
   /* ─── Reactor block (colored card per reactor type) ─────────── */
   .cre2-reactor-block {
     border-radius: var(--t2-radius-md);
     overflow:      hidden;
     margin:        20px 0;
     border:        1px solid var(--t2-border);
     box-shadow:    0 2px 6px rgba(0, 0, 0, 0.06);
   }
   
   /* Matches tdb-badge label: 11px / 700 / uppercase / 1.5px tracking */
   .cre2-reactor-block-header {
     padding:        10px 18px;
     font-family:    var(--t2-font);
     font-size:      11px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 1.5px;
   }
   .cre2-reactor-block-body {
     padding:    18px 20px;
     background: var(--t2-surface);
   }
   .cre2-reactor-block-body > .cre2-eq-box:first-child { margin-top: 0; }
   
   .cre2-reactor-block--batch .cre2-reactor-block-header {
     background:    rgba(180, 105, 14, 0.08);
     color:         var(--t2-batch);
     border-bottom: 1px solid var(--t2-amber-border);
   }
   .cre2-reactor-block--cstr .cre2-reactor-block-header {
     background:    rgba(192, 57, 43, 0.08);
     color:         var(--t2-cstr);
     border-bottom: 1px solid rgba(192, 57, 43, 0.18);
   }
   .cre2-reactor-block--pfr .cre2-reactor-block-header {
     background:    var(--t2-blue-dim);
     color:         var(--t2-pfr);
     border-bottom: 1px solid var(--t2-blue-border);
   }
   .cre2-reactor-block--pbr .cre2-reactor-block-header {
     background:    var(--t2-green-dim);
     color:         var(--t2-pbr);
     border-bottom: 1px solid var(--t2-green-border);
   }
   
   /* ─── Levenspiel plot container ─────────────────────────────── */
   .cre2-levenspiel-container {
     background:    var(--t2-surface);
     border:        1px solid var(--t2-border);
     border-radius: var(--t2-radius-md);
     padding:       24px;
     margin:        24px 0;
     box-shadow:    0 2px 8px rgba(0, 0, 0, 0.06);
   }
   
   /* Matches tdb-card-tag: 12px / 700 / uppercase / 0.8px tracking */
   .cre2-levenspiel-title {
     font-family:    var(--t2-font);
     font-size:      12px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 0.8px;
     color:          var(--t2-text-dim);
     margin-bottom:  16px;
   }
   
   .cre2-levenspiel-svg {
     width:         100%;
     max-width:     520px;
     display:       block;
     margin:        0 auto;
     border-radius: var(--t2-radius-sm);
   }
   
   /* Matches tdb-footer / diagram-caption: 12px / 400 / text-dim */
   .cre2-levenspiel-caption {
     font-family: var(--t2-font);
     font-size:   12px;
     font-weight: 400;
     color:       var(--t2-text-sub);
     text-align:  center;
     margin-top:  14px;
     font-style:  italic;
     line-height: 1.5;
   }
   
   /* ─── Reactors in Series diagram ────────────────────────────── */
   .cre2-series-diagram {
     display:       flex;
     align-items:   center;
     gap:           8px;
     flex-wrap:     wrap;
     margin:        24px 0;
     padding:       20px;
     background:    var(--t2-surface);
     border:        1px solid var(--t2-border);
     border-radius: var(--t2-radius-md);
   }
   
   .cre2-series-reactor {
     display:         flex;
     flex-direction:  column;
     align-items:     center;
     justify-content: center;
     width:           90px;
     height:          90px;
     border-radius:   var(--t2-radius-md);
     border:          2px solid;
     padding:         10px;
     text-align:      center;
     flex-shrink:     0;
   }
   
   .cre2-series-reactor--cstr {
     background:   rgba(192, 57, 43, 0.08);
     border-color: rgba(192, 57, 43, 0.35);
   }
   .cre2-series-reactor--pfr {
     background:     var(--t2-blue-dim);
     border-color:   rgba(37, 99, 235, 0.35);
     border-radius:  40px;
   }
   
   /* Matches tdb-card-tag: 12px / 700 / uppercase */
   .cre2-series-label {
     font-family:    var(--t2-font);
     font-size:      11px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 0.8px;
   }
   .cre2-series-reactor--cstr .cre2-series-label { color: var(--t2-cstr); }
   .cre2-series-reactor--pfr  .cre2-series-label { color: var(--t2-pfr); }
   
   /* Matches tdb body values: 13px / 700 / text-mid */
   .cre2-series-vol {
     font-family: var(--t2-font);
     font-size:   13px;
     font-weight: 700;
     color:       var(--t2-text-mid);
     margin:      4px 0 2px;
   }
   /* Matches caption / dim text: 12px / 400 */
   .cre2-series-rate {
     font-family: var(--t2-font);
     font-size:   12px;
     font-weight: 400;
     color:       var(--t2-text-sub);
   }
   
   .cre2-series-arrow {
     display:        flex;
     flex-direction: column;
     align-items:    center;
     gap:            4px;
     flex-shrink:    0;
   }
   /* Matches meta-item: 12px / 400 / accent */
   .cre2-series-arrow span {
     font-family: var(--t2-font);
     font-size:   12px;
     font-weight: 400;
     color:       var(--t2-accent);
     white-space: nowrap;
   }
   .cre2-arrow-line {
     font-size:   20px;
     color:       var(--t2-text-sub);
     line-height: 1;
   }
   
   /* ─── Tower (CRE Algorithm) ─────────────────────────────────── */
   .cre2-tower {
     margin:         20px 0;
     display:        flex;
     flex-direction: column;
     gap:            0;
   }
   
   .cre2-tower-level {
     display:     flex;
     gap:         16px;
     padding:     16px 20px;
     border:      1px solid var(--t2-border-light);
     border-bottom: none;
     align-items: flex-start;
     transition:  background 0.15s;
   }
   .cre2-tower-level:first-child { border-radius: var(--t2-radius-md) var(--t2-radius-md) 0 0; }
   .cre2-tower-level:last-child  { border-bottom: 1px solid var(--t2-border-light); border-radius: 0 0 var(--t2-radius-md) var(--t2-radius-md); }
   .cre2-tower-level:hover       { background: rgba(40, 167, 69, 0.03); }
   
   .cre2-tower-level--1 { background: rgba(40, 167, 69, 0.05); }
   .cre2-tower-level--2 { background: rgba(37, 99, 235, 0.05); }
   .cre2-tower-level--3 { background: rgba(180, 105, 14, 0.05); }
   .cre2-tower-level--4 { background: rgba(8, 145, 178, 0.05); }
   .cre2-tower-level--5 { background: rgba(192, 57, 43, 0.05); }
   
   .cre2-tower-num {
     min-width:       32px;
     height:          32px;
     border-radius:   50%;
     display:         flex;
     align-items:     center;
     justify-content: center;
     font-family:     var(--t2-font);
     font-weight:     700;
     font-size:       13px;
     color:           #fff;
     flex-shrink:     0;
     box-shadow:      0 2px 8px var(--t2-accent-glow);
   }
   .cre2-tower-level--1 .cre2-tower-num { background: var(--t2-accent); }
   .cre2-tower-level--2 .cre2-tower-num { background: var(--t2-pfr); }
   .cre2-tower-level--3 .cre2-tower-num { background: var(--t2-amber); }
   .cre2-tower-level--4 .cre2-tower-num { background: var(--t2-cyan); }
   .cre2-tower-level--5 .cre2-tower-num { background: var(--t2-cstr); }
   
   .cre2-tower-content { flex: 1 1; }
   /* Matches .tdb-card-title: 17px / 700 / -0.1px */
   .cre2-tower-content h4 {
     font-family:    var(--t2-font);
     font-size:      17px;
     font-weight:    700;
     color:          var(--t2-text);
     margin-bottom:  4px;
     letter-spacing: -0.1px;
   }
   /* Matches .tdb-card-desc: 14px / 400 / 1.65 */
   .cre2-tower-content p {
     font-family: var(--t2-font);
     font-size:   14px;
     font-weight: 400;
     color:       var(--t2-text-muted);
     margin:      0;
     line-height: 1.65;
   }
   
   /* ─── Images ────────────────────────────────────────────────── */
   img {
     max-width: 100%;
     height: auto;
     display: block;
     margin: 20px auto;
     border-radius: var(--t2-radius-md);
     box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
     transition: transform 0.2s ease, box-shadow 0.2s ease;
     border: 1px solid var(--t2-border-light);
   }
   img:hover {
     transform: translateY(-2px);
     box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
   }
   .cre2-section img { margin: 20px auto; max-width: 90%; }
   
   /* ─── Footer — matches Tutorial1 cre-footer ────────────────── */
   /* Matches tdb footer: 12px / 400 / text-dim */
   .cre2-footer {
     border-top:  1px solid var(--t2-border-light);
     padding-top: 24px;
     margin-top:  40px;
     font-family: var(--t2-font);
     font-size:   12px;
     font-weight: 400;
     color:       var(--t2-text-dim);
     line-height: 1.6;
   }
   
   /* ─── Animation ─────────────────────────────────────────────── */
   @keyframes fadeIn2 {
     from { opacity: 0; transform: translateY(8px); }
     to   { opacity: 1; transform: translateY(0); }
   }
   
   /* ─── Responsive ────────────────────────────────────────────── */
   @media (max-width: 1200px) {
     .cre2-main-inner { padding: 40px 40px 64px; }
   }
   
   @media (max-width: 900px) {
     .cre2-sidebar { display: none !important; }
     .cre2-main-inner     { padding: 28px 20px 52px; max-width: 100%; }
     .cre2-toc-grid       { grid-template-columns: 1fr 1fr; }
     .cre2-series-diagram { gap: 6px; }
     .cre2-hero h1        { font-size: 26px; }
     .cre2-hero-desc      { font-size: 15px; }
   }
   
   @media (max-width: 600px) {
     .cre2-card-grid        { grid-template-columns: 1fr; }
     .cre2-toc-grid         { grid-template-columns: 1fr; }
     .cre2-series-diagram   { flex-direction: column; align-items: flex-start; }
     .cre2-arrow-line       { transform: rotate(90deg); }
   }`, "",{"version":3,"sources":["webpack://./src/styles/Tutorial2.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;GAI9D,kEAAkE;GAClE;KACE,2BAA2B;KAC3B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;;KAE7B,mBAAmB;KACnB,6BAA6B;KAC7B,6CAA6C;KAC7C,6CAA6C;KAC7C,6BAA6B;;KAE7B,qBAAqB;KACrB,6BAA6B;KAC7B,8CAA8C;KAC9C,8CAA8C;KAC9C,6BAA6B;KAC7B,6CAA6C;KAC7C,6CAA6C;KAC7C,6BAA6B;KAC7B,6CAA6C;KAC7C,6CAA6C;KAC7C,6CAA6C;KAC7C,6CAA6C;;KAE7C,wBAAwB;KACxB,6BAA6B;KAC7B,6CAA6C;KAC7C,6CAA6C;;KAE7C,yBAAyB;KACzB,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;;KAE7B,YAAY;KACZ,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;;KAE7B,0BAA0B;KAC1B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;;KAE7B,sDAAsD;KACtD,wFAAwF;KACxF,yDAAyD;;KAEzD,YAAY;KACZ,mBAAmB;KACnB,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;;KAEpB,wCAAwC;KACxC,mBAAmB;KACnB,mBAAmB;KACnB,mBAAmB;;KAEnB,qBAAqB;GACvB;;GAEA,kEAAkE;GAClE;;;KAGE,sBAAsB;KACtB,SAAS;KACT,UAAU;GACZ;;GAEA,kEAAkE;GAClE,6BAA6B,UAAU,EAAE,WAAW,EAAE;GACtD,6BAA6B,uBAAuB,EAAE;GACtD,6BAA6B,4BAA4B,EAAE,kBAAkB,EAAE;GAC/E,kCAAkC,gCAAgC,EAAE;;GAEpE;;mEAEgE;GAChE;KACE,2BAA2B;KAC3B,yBAAyB;KACzB,2BAA2B;KAC3B,iBAAiB;KACjB,iBAAiB;KACjB,iBAAiB;KACjB,iBAAiB;KACjB,gBAAgB;KAChB,mBAAmB;GACrB;;GAEA;;mEAEgE;GAChE;KACE,oBAAoB;KACpB,mCAAmC;KACnC,mCAAmC;KACnC,oCAAoC;KACpC,0CAA0C;KAC1C,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;KACpB,iBAAiB;KACjB,wBAAwB;GAC1B;;GAEA;KACE,gBAAgB,cAAc,EAAE;GAClC;;GAEA;KACE,uCAAuC;KACvC,6BAA6B;KAC7B,yCAAyC;KACzC,qBAAqB;KACrB,gBAAgB;KAChB,iBAAiB;GACnB;;GAEA,2EAA2E;GAC3E;KACE,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,mBAAmB;KACnB,gCAAgC;KAChC,mBAAmB;GACrB;;GAEA,mDAAmD;GACnD;KACE,2BAA2B;KAC3B,iBAAiB;KACjB,gBAAgB;KAChB,iCAAiC;GACnC;;GAEA,2EAA2E;GAC3E;KACE,+BAA+B;KAC/B,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;KACrB,gCAAgC;KAChC,mBAAmB;GACrB;;GAEA,uDAAuD;GACvD;KACE,sBAAsB;KACtB,kCAAkC;KAClC,+BAA+B;KAC/B,qBAAqB;KACrB,oBAAoB;KACpB,qCAAqC;KACrC,qBAAqB;KACrB,sCAAsC;KACtC,0BAA0B;KAC1B,oBAAoB;KACpB,wBAAwB;GAC1B;GACA;KACE,iCAAiC;KACjC,0CAA0C;KAC1C,mCAAmC;GACrC;GACA;KACE,kBAAkB;KAClB,kBAAkB;KAClB,gCAAgC;GAClC;;GAEA;;mEAEgE;GAChE;KACE,eAAa;KACb,gBAAgB;KAChB,kBAAkB;KAClB,aAAa;KACb,8BAA8B;GAChC;;GAEA,6CAA6C;GAC7C;KACE,eAAe;KACf,uBAAuB;GACzB;;GAEA,kEAAkE;GAClE;KACE,mCAAmC;KACnC,oBAAoB;KACpB,wCAAwC;GAC1C;;GAEA,4EAA4E;GAC5E;KACE,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,mBAAmB;KACnB,gCAAgC;KAChC,oBAAoB;GACtB;;GAEA,4DAA4D;GAC5D;KACE,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,mBAAmB;KACnB,sBAAsB;KACtB,oBAAoB;KACpB,8BAA8B;GAChC;;GAEA,8EAA8E;GAC9E;KACE,2BAA2B;KAC3B,iBAAiB;KACjB,gBAAgB;KAChB,iCAAiC;KACjC,kBAAkB;KAClB,gBAAgB;KAChB,cAAc;GAChB;;GAEA;KACE,gBAAgB;KAChB,gBAAgB;KAChB,gBAAgB;KAChB,gBAAgB;GAClB;;GAEA,iDAAiD;GACjD;KACE,2BAA2B;KAC3B,iBAAiB;KACjB,gBAAgB;KAChB,+BAA+B;KAC/B,iBAAiB;KACjB,mBAAmB;KACnB,gBAAgB;GAClB;;GAEA;KACE,kBAAkB;KAClB,kBAAkB;KAClB,kBAAkB;KAClB,+BAA+B;KAC/B,2BAA2B;KAC3B,gBAAgB;GAClB;;GAEA,kEAAkE;GAClE;KACE,gCAAgC;KAChC,yCAAyC;KACzC,yCAAyC;KACzC,kCAAkC;KAClC,wBAAwB;KACxB,mBAAmB;KACnB,4CAA4C;GAC9C;;GAEA,2EAA2E;GAC3E;KACE,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;KACrB,gCAAgC;KAChC,oBAAoB;GACtB;;GAEA;KACE,2BAA2B;KAC3B,4DAA4D;KAC5D,+BAA+B;GACjC;;GAEA,oDAAoD;GACpD;KACE,+BAA+B;KAC/B,qBAAqB;KACrB,oBAAoB;KACpB,+BAA+B;KAC/B,qBAAqB;KACrB,qBAAqB;KACrB,uBAAuB;KACvB,sBAAsB;KACtB,4BAA4B;GAC9B;GACA,uBAAuB,uBAAuB,EAAE;;GAEhD,kEAAkE;GAClE,0EAA0E;GAC1E;KACE,4BAA4B;KAC5B,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;KACrB,uBAAuB;KACvB,mCAAmC;KACnC,oBAAoB;GACtB;;GAEA;KACE,oCAAoC;KACpC,2BAA2B;KAC3B,4CAA4C;GAC9C;GACA;KACE,8BAA8B;KAC9B,0BAA0B;KAC1B,2CAA2C;GAC7C;;GAEA,kEAAkE;GAClE;KACE,sCAAsC;KACtC,uBAAuB;GACzB;;GAEA,4EAA4E;GAC5E;KACE,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,mBAAmB;KACnB,gCAAgC;KAChC,mBAAmB;GACrB;;GAEA,+DAA+D;GAC/D;KACE,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,sBAAsB;KACtB,8BAA8B;KAC9B,mBAAmB;KACnB,oBAAoB;GACtB;;GAEA;KACE,mBAAmB;KACnB,kBAAkB;KAClB,+BAA+B;KAC/B,mBAAmB;KACnB,kBAAkB;GACpB;;GAEA,iDAAiD;GACjD;KACE,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,sBAAsB;KACtB,8BAA8B;KAC9B,2BAA2B;GAC7B;;GAEA,yDAAyD;GACzD;KACE,6BAA6B;KAC7B,mBAAmB;KACnB,kBAAkB;KAClB,mBAAmB;KACnB,mCAAmC;KACnC,kBAAkB;GACpB;;GAEA,8DAA8D;GAC9D;;KAEE,6BAA6B;KAC7B,mBAAmB;KACnB,kBAAkB;KAClB,mBAAmB;KACnB,mBAAmB;KACnB,mCAAmC;KACnC,mBAAmB;GACrB;GACA,mBAAmB,kBAAkB,EAAE;;GAEvC,kEAAkE;GAClE;KACE,8BAA8B;KAC9B,yCAAyC;KACzC,wCAAwC;KACxC,kCAAkC;KAClC,wBAAwB;KACxB,qBAAqB;KACrB,mBAAmB;GACrB;;GAEA,+DAA+D;GAC/D;KACE,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;KACrB,kCAAkC;KAClC,mBAAmB;GACrB;;GAEA;KACE,gCAAgC;KAChC,iBAAiB;KACjB,2BAA2B;KAC3B,cAAc;KACd,qBAAqB;GACvB;;GAEA,qDAAqD;GACrD;KACE,2BAA2B;KAC3B,iBAAiB;KACjB,gBAAgB;KAChB,+BAA+B;KAC/B,gBAAgB;KAChB,qBAAqB;KACrB,gBAAgB;GAClB;;GAEA,kEAAkE;GAClE;KACE,kCAAkC;KAClC,wBAAwB;KACxB,qBAAqB;KACrB,mBAAmB;GACrB;GACA,4DAA4D;GAC5D;KACE,2BAA2B;KAC3B,iBAAiB;KACjB,gBAAgB;KAChB,iCAAiC;KACjC,cAAc;KACd,iBAAiB;GACnB;GACA,sBAAsB,8BAA8B,GAAG,uCAAuC,GAAG;GACjG,sBAAsB,+BAA+B,EAAE,wCAAwC,EAAE;GACjG,sBAAsB,+BAA+B,EAAE,wCAAwC,EAAE;GACjG,sBAAsB,8BAA8B,GAAG,uCAAuC,GAAG;;GAEjG,kEAAkE;GAClE;KACE,2BAA2B;KAC3B,4DAA4D;KAC5D,2BAA2B;KAC3B,6BAA6B;GAC/B;;GAEA;KACE,gCAAgC;KAChC,yCAAyC;KACzC,kCAAkC;KAClC,wBAAwB;KACxB,oEAAoE;KACpE,4CAA4C;GAC9C;GACA;KACE,8BAA8B;KAC9B,4CAA4C;KAC5C,8BAA8B;GAChC;GACA,kBAAkB,eAAe,EAAE,kBAAkB,EAAE;;GAEvD,iDAAiD;GACjD;KACE,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,8BAA8B;KAC9B,mBAAmB;KACnB,sBAAsB;GACxB;GACA,2DAA2D;GAC3D;KACE,2BAA2B;KAC3B,iBAAiB;KACjB,gBAAgB;KAChB,iCAAiC;KACjC,cAAc;KACd,iBAAiB;GACnB;;GAEA,kEAAkE;GAClE,cAAc,cAAc,EAAE;;GAE9B;KACE,mBAAmB;KACnB,mBAAmB;KACnB,mBAAmB;KACnB,yBAAyB;GAC3B;;GAEA;KACE,qBAAqB;KACrB,qBAAqB;KACrB,iCAAiC;KACjC,qBAAqB;KACrB,oBAAoB;KACpB,qBAAqB;KACrB,uBAAuB;KACvB,uBAAuB;KACvB,+BAA+B;KAC/B,oBAAoB;KACpB,qBAAqB;KACrB,oBAAoB;KACpB,kBAAkB;KAClB,gDAAgD;GAClD;;GAEA,qBAAqB,SAAO,EAAE;GAC9B,iDAAiD;GACjD;KACE,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,8BAA8B;KAC9B,mBAAmB;KACnB,sBAAsB;GACxB;GACA,8CAA8C;GAC9C;KACE,2BAA2B;KAC3B,iBAAiB;KACjB,gBAAgB;KAChB,iCAAiC;KACjC,oBAAoB;KACpB,iBAAiB;GACnB;;GAEA,kEAAkE;GAClE;KACE,gCAAgC;KAChC,yCAAyC;KACzC,yCAAyC;KACzC,kCAAkC;KAClC,wBAAwB;KACxB,qBAAqB;KACrB,4CAA4C;GAC9C;;GAEA,gEAAgE;GAChE;KACE,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;KACrB,gCAAgC;KAChC,mBAAmB;GACrB;GACA,iDAAiD;GACjD;KACE,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,8BAA8B;KAC9B,oBAAoB;KACpB,sBAAsB;GACxB;GACA,8CAA8C;GAC9C;KACE,6BAA6B;KAC7B,mBAAmB;KACnB,kBAAkB;KAClB,mCAAmC;KACnC,mBAAmB;KACnB,mBAAmB;GACrB;;GAEA,mEAAmE;GACnE;KACE,qBAAqB;KACrB,yBAAyB;KACzB,uBAAuB;KACvB,+BAA+B;KAC/B,qBAAqB;KACrB,kCAAkC;KAClC,oCAAoC;KACpC,uBAAuB;KACvB,2CAA2C;GAC7C;GACA,oBAAoB,2BAA2B,EAAE;GACjD,kEAAkE;GAClE;KACE,yBAAyB;KACzB,oBAAoB;KACpB,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;KACrB,oCAAoC;KACpC,0CAA0C;GAC5C;GACA,yDAAyD;GACzD;KACE,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,gDAAgD;KAChD,oCAAoC;KACpC,mBAAmB;KACnB,oBAAoB;GACtB;GACA,+BAA+B,mBAAmB,EAAE;GACpD,0BAA0B,mCAAmC,EAAE;;GAE/D,kEAAkE;GAClE;KACE,kCAAkC;KAClC,qBAAqB;KACrB,gCAAgC;KAChC,6BAA6B;KAC7B,sBAAsB;KACtB,kCAAkC;KAClC,+CAA+C;GACjD;;GAEA,kEAAkE;GAClE,gEAAgE;GAChE;KACE,4BAA4B;KAC5B,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;KACrB,uBAAuB;KACvB,mCAAmC;KACnC,sBAAsB;GACxB;GACA,qBAAqB,oCAAoC,EAAE,sBAAsB,EAAE,wCAAwC,EAAE;GAC7H,qBAAqB,mCAAmC,GAAG,qBAAqB,GAAG,yCAAyC,EAAE;GAC9H,qBAAqB,8BAA8B,SAAS,oBAAoB,IAAI,uCAAuC,EAAE;GAC7H,qBAAqB,+BAA+B,QAAQ,oBAAoB,IAAI,wCAAwC,EAAE;;GAE9H,kEAAkE;GAClE;KACE,kCAAkC;KAClC,qBAAqB;KACrB,qBAAqB;KACrB,yCAAyC;KACzC,4CAA4C;GAC9C;;GAEA,qEAAqE;GACrE;KACE,yBAAyB;KACzB,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;GACvB;GACA;KACE,qBAAqB;KACrB,6BAA6B;GAC/B;GACA,sDAAsD,aAAa,EAAE;;GAErE;KACE,uCAAuC;KACvC,8BAA8B;KAC9B,+CAA+C;GACjD;GACA;KACE,sCAAsC;KACtC,6BAA6B;KAC7B,gDAAgD;GAClD;GACA;KACE,iCAAiC;KACjC,4BAA4B;KAC5B,8CAA8C;GAChD;GACA;KACE,kCAAkC;KAClC,4BAA4B;KAC5B,+CAA+C;GACjD;;GAEA,kEAAkE;GAClE;KACE,gCAAgC;KAChC,yCAAyC;KACzC,kCAAkC;KAClC,mBAAmB;KACnB,qBAAqB;KACrB,4CAA4C;GAC9C;;GAEA,kEAAkE;GAClE;KACE,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;KACrB,kCAAkC;KAClC,oBAAoB;GACtB;;GAEA;KACE,mBAAmB;KACnB,oBAAoB;KACpB,oBAAoB;KACpB,qBAAqB;KACrB,kCAAkC;GACpC;;GAEA,gEAAgE;GAChE;KACE,2BAA2B;KAC3B,iBAAiB;KACjB,gBAAgB;KAChB,+BAA+B;KAC/B,mBAAmB;KACnB,iBAAiB;KACjB,mBAAmB;KACnB,gBAAgB;GAClB;;GAEA,kEAAkE;GAClE;KACE,mBAAmB;KACnB,qBAAqB;KACrB,kBAAkB;KAClB,mBAAmB;KACnB,qBAAqB;KACrB,mBAAmB;KACnB,gCAAgC;KAChC,yCAAyC;KACzC,kCAAkC;GACpC;;GAEA;KACE,qBAAqB;KACrB,uBAAuB;KACvB,uBAAuB;KACvB,uBAAuB;KACvB,qBAAqB;KACrB,qBAAqB;KACrB,oCAAoC;KACpC,0BAA0B;KAC1B,qBAAqB;KACrB,uBAAuB;KACvB,kBAAkB;GACpB;;GAEA;KACE,qCAAqC;KACrC,qCAAqC;GACvC;GACA;KACE,kCAAkC;KAClC,uCAAuC;KACvC,oBAAoB;GACtB;;GAEA,iDAAiD;GACjD;KACE,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;GACvB;GACA,gDAAgD,qBAAqB,EAAE;GACvE,gDAAgD,oBAAoB,EAAE;;GAEtE,mDAAmD;GACnD;KACE,2BAA2B;KAC3B,iBAAiB;KACjB,gBAAgB;KAChB,+BAA+B;KAC/B,sBAAsB;GACxB;GACA,2CAA2C;GAC3C;KACE,2BAA2B;KAC3B,iBAAiB;KACjB,gBAAgB;KAChB,+BAA+B;GACjC;;GAEA;KACE,oBAAoB;KACpB,sBAAsB;KACtB,sBAAsB;KACtB,mBAAmB;KACnB,iBAAiB;GACnB;GACA,2CAA2C;GAC3C;KACE,2BAA2B;KAC3B,iBAAiB;KACjB,gBAAgB;KAChB,6BAA6B;KAC7B,mBAAmB;GACrB;GACA;KACE,iBAAiB;KACjB,+BAA+B;KAC/B,cAAc;GAChB;;GAEA,kEAAkE;GAClE;KACE,sBAAsB;KACtB,oBAAoB;KACpB,sBAAsB;KACtB,iBAAiB;GACnB;;GAEA;KACE,iBAAiB;KACjB,iBAAiB;KACjB,sBAAsB;KACtB,6CAA6C;KAC7C,mBAAmB;KACnB,uBAAuB;KACvB,6BAA6B;GAC/B;GACA,gCAAgC,0DAA0D,EAAE;GAC5F,gCAAgC,+CAA+C,EAAE,0DAA0D,EAAE;GAC7I,gCAAgC,mCAAmC,EAAE;;GAErE,uBAAuB,mCAAmC,EAAE;GAC5D,uBAAuB,mCAAmC,EAAE;GAC5D,uBAAuB,oCAAoC,EAAE;GAC7D,uBAAuB,mCAAmC,EAAE;GAC5D,uBAAuB,mCAAmC,EAAE;;GAE5D;KACE,qBAAqB;KACrB,qBAAqB;KACrB,oBAAoB;KACpB,qBAAqB;KACrB,uBAAuB;KACvB,uBAAuB;KACvB,+BAA+B;KAC/B,oBAAoB;KACpB,qBAAqB;KACrB,qBAAqB;KACrB,kBAAkB;KAClB,gDAAgD;GAClD;GACA,uCAAuC,4BAA4B,EAAE;GACrE,uCAAuC,yBAAyB,EAAE;GAClE,uCAAuC,2BAA2B,EAAE;GACpE,uCAAuC,0BAA0B,EAAE;GACnE,uCAAuC,0BAA0B,EAAE;;GAEnE,sBAAsB,SAAO,EAAE;GAC/B,iDAAiD;GACjD;KACE,8BAA8B;KAC9B,oBAAoB;KACpB,mBAAmB;KACnB,8BAA8B;KAC9B,mBAAmB;KACnB,sBAAsB;GACxB;GACA,8CAA8C;GAC9C;KACE,2BAA2B;KAC3B,iBAAiB;KACjB,gBAAgB;KAChB,iCAAiC;KACjC,cAAc;KACd,iBAAiB;GACnB;;GAEA,kEAAkE;GAClE;KACE,eAAe;KACf,YAAY;KACZ,cAAc;KACd,iBAAiB;KACjB,kCAAkC;KAClC,yCAAyC;KACzC,qDAAqD;KACrD,wCAAwC;GAC1C;GACA;KACE,2BAA2B;KAC3B,0CAA0C;GAC5C;GACA,oBAAoB,iBAAiB,EAAE,cAAc,EAAE;;GAEvD,iEAAiE;GACjE,8CAA8C;GAC9C;KACE,6CAA6C;KAC7C,iBAAiB;KACjB,iBAAiB;KACjB,2BAA2B;KAC3B,iBAAiB;KACjB,gBAAgB;KAChB,+BAA+B;KAC/B,gBAAgB;GAClB;;GAEA,kEAAkE;GAClE;KACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;KAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;GAC/C;;GAEA,kEAAkE;GAClE;KACE,mBAAmB,uBAAuB,EAAE;GAC9C;;GAEA;KACE,gBAAgB,wBAAwB,EAAE;KAC1C,uBAAuB,uBAAuB,EAAE,eAAe,EAAE;KACjE,uBAAuB,8BAA8B,EAAE;KACvD,uBAAuB,QAAQ,EAAE;KACjC,uBAAuB,eAAe,EAAE;KACxC,uBAAuB,eAAe,EAAE;GAC1C;;GAEA;KACE,yBAAyB,0BAA0B,EAAE;KACrD,yBAAyB,0BAA0B,EAAE;KACrD,yBAAyB,sBAAsB,EAAE,uBAAuB,EAAE;KAC1E,yBAAyB,wBAAwB,EAAE;GACrD","sourcesContent":["/* ============================================================\n   Tutorial2.css  —  KinetiQ CRE Course Notes Page — Lecture 2\n   Font system: Inter throughout — identical tokens, sizes,\n   weights & letter-spacing to TutorialsDashboard.css & Tutorial1.css\n   ============================================================ */\n\n   @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');\n\n   /* ─── Design tokens — mirrored from TutorialsDashboard.css ──── */\n   :root {\n     /* Backgrounds & surfaces */\n     --t2-bg:              #f7f9fa;\n     --t2-surface:         #ffffff;\n     --t2-panel:           #f3f4f6;\n     --t2-card:            #ffffff;\n     --t2-sidebar-bg:      #f0f2f4;\n     --t2-sidebar-header:  #e8eaed;\n     --t2-code-bg:         #f5f7fa;\n     --t2-eq-bg:           #fafbfc;\n   \n     /* Accent — green */\n     --t2-accent:          #28a745;\n     --t2-accent-dim:      rgba(40, 167, 69, 0.10);\n     --t2-accent-glow:     rgba(40, 167, 69, 0.15);\n     --t2-accent-hover:    #1e8c3a;\n   \n     /* Semantic colours */\n     --t2-amber:           #b4690e;\n     --t2-amber-dim:       rgba(180, 105, 14, 0.08);\n     --t2-amber-border:    rgba(180, 105, 14, 0.22);\n     --t2-cyan:            #0891b2;\n     --t2-cyan-dim:        rgba(8, 145, 178, 0.08);\n     --t2-cyan-border:     rgba(8, 145, 178, 0.22);\n     --t2-blue:            #2563eb;\n     --t2-blue-dim:        rgba(37, 99, 235, 0.08);\n     --t2-blue-border:     rgba(37, 99, 235, 0.22);\n     --t2-green-dim:       rgba(40, 167, 69, 0.08);\n     --t2-green-border:    rgba(40, 167, 69, 0.22);\n   \n     /* Purple — tdb-purple */\n     --t2-purple:          #5624d0;\n     --t2-purple-light:    rgba(86, 36, 208, 0.07);\n     --t2-purple-border:   rgba(86, 36, 208, 0.18);\n   \n     /* Reactor type colours */\n     --t2-batch:           #b4690e;\n     --t2-cstr:            #c0392b;\n     --t2-pfr:             #2563eb;\n     --t2-pbr:             #28a745;\n   \n     /* Borders */\n     --t2-border:          #d1d7dc;\n     --t2-border-light:    #e8ecef;\n     --t2-border-mid:      #bbc1c8;\n   \n     /* Text — tdb-text scale */\n     --t2-text:            #1c1d1f;\n     --t2-text-muted:      #4a4f5a;\n     --t2-text-mid:        #3a3f4a;\n     --t2-text-dim:        #6a6f73;\n     --t2-text-sub:        #8a8f96;\n   \n     /* Font — identical to tdb-font & Tutorial1 --t-font */\n     --t2-font:            'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n     --t2-font-mono:       'Courier New', 'Courier', monospace;\n   \n     /* Spacing */\n     --t2-space-xs:  6px;\n     --t2-space-sm:  10px;\n     --t2-space-md:  16px;\n     --t2-space-lg:  24px;\n     --t2-space-xl:  40px;\n     --t2-space-2xl: 56px;\n   \n     /* Radii — tdb uses 6px (md), 4px (sm) */\n     --t2-radius-sm: 4px;\n     --t2-radius-md: 6px;\n     --t2-radius-lg: 8px;\n   \n     --t2-sidebar-w: 260px;\n   }\n   \n   /* ─── Reset ─────────────────────────────────────────────────── */\n   *,\n   *::before,\n   *::after {\n     box-sizing: border-box;\n     margin: 0;\n     padding: 0;\n   }\n   \n   /* ─── Scrollbar ─────────────────────────────────────────────── */\n   ::-webkit-scrollbar        { width: 5px; height: 5px; }\n   ::-webkit-scrollbar-track  { background: transparent; }\n   ::-webkit-scrollbar-thumb  { background: var(--t2-border); border-radius: 3px; }\n   ::-webkit-scrollbar-thumb:hover { background: var(--t2-border-mid); }\n   \n   /* ══════════════════════════════════════════════════════════════\n      CONTAINER — base Inter 15px / 400 / 1.7 matching TutorialsDashboard\n   ══════════════════════════════════════════════════════════════ */\n   .cre2-container {\n     font-family: var(--t2-font);\n     background:  var(--t2-bg);\n     color:       var(--t2-text);\n     display:     flex;\n     height:      100%;\n     width:       100%;\n     font-size:   15px;\n     line-height: 1.7;\n     overflow:    hidden;\n   }\n   \n   /* ══════════════════════════════════════════════════════════════\n      SIDEBAR\n   ══════════════════════════════════════════════════════════════ */\n   .cre2-sidebar {\n     display:        none;\n     width:          var(--t2-sidebar-w);\n     min-width:      var(--t2-sidebar-w);\n     background:     var(--t2-sidebar-bg);\n     border-right:   1px solid var(--t2-border);\n     height:         100%;\n     overflow-y:     auto;\n     padding-bottom: 40px;\n     font-size:      13px;\n     flex-shrink:    0;\n     position:       relative;\n   }\n   \n   @media (min-width: 1600px) {\n     .cre2-sidebar { display: block; }\n   }\n   \n   .cre2-sidebar-header {\n     background:    var(--t2-sidebar-header);\n     padding:       20px 18px 16px;\n     border-bottom: 1px solid var(--t2-border);\n     position:      sticky;\n     top:           0;\n     z-index:       10;\n   }\n   \n   /* Matches tdb-header-tag: 13px / 700 / uppercase / 2px tracking / accent */\n   .cre2-sidebar-header h1 {\n     font-family:    var(--t2-font);\n     font-size:      13px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t2-accent);\n     margin-bottom:  4px;\n   }\n   \n   /* Matches tdb-card-desc: 14px / 400 / text-muted */\n   .cre2-sidebar-header p {\n     font-family: var(--t2-font);\n     font-size:   14px;\n     font-weight: 400;\n     color:       var(--t2-text-muted);\n   }\n   \n   /* Matches tdb-card-tag: 12px / 700 / uppercase / 0.8px tracking / purple */\n   .cre2-nav-section {\n     padding:        14px 0 4px 18px;\n     font-family:    var(--t2-font);\n     font-size:      12px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 0.8px;\n     color:          var(--t2-purple);\n     margin-top:     8px;\n   }\n   \n   /* Matches tdb-popup-bullets: 13px / 400 / text-muted */\n   .cre2-nav-item {\n     display:         block;\n     padding:         7px 18px 7px 28px;\n     font-family:     var(--t2-font);\n     font-size:       13px;\n     font-weight:     400;\n     color:           var(--t2-text-muted);\n     text-decoration: none;\n     border-left:     3px solid transparent;\n     transition:      all 0.15s;\n     line-height:     1.5;\n     cursor:          pointer;\n   }\n   .cre2-nav-item:hover {\n     color:             var(--t2-text);\n     background:        rgba(40, 167, 69, 0.06);\n     border-left-color: var(--t2-accent);\n   }\n   .cre2-nav-item--sub {\n     padding-left: 40px;\n     font-size:    12px;\n     color:        var(--t2-text-dim);\n   }\n   \n   /* ══════════════════════════════════════════════════════════════\n      MAIN CONTENT\n   ══════════════════════════════════════════════════════════════ */\n   .cre2-main {\n     flex:       1;\n     overflow-y: auto;\n     overflow-x: hidden;\n     min-width:  0;\n     animation:  fadeIn2 0.25s ease;\n   }\n   \n   /* Matches Tutorial1 cre-main-inner padding */\n   .cre2-main-inner {\n     margin:  0 auto;\n     padding: 52px 64px 88px;\n   }\n   \n   /* ─── Hero — matches tdb-header exactly ─────────────────────── */\n   .cre2-hero {\n     margin-bottom:  var(--t2-space-2xl);\n     padding-bottom: 32px;\n     border-bottom:  2px solid var(--t2-text);\n   }\n   \n   /* Matches .tdb-header-tag: 13px / 700 / uppercase / 2px tracking / purple */\n   .cre2-hero-tag {\n     font-family:    var(--t2-font);\n     font-size:      13px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t2-purple);\n     margin-bottom:  10px;\n   }\n   \n   /* Matches .tdb-header-title: 32px / 800 / -0.5px / 1.2 lh */\n   .cre2-hero h1 {\n     font-family:    var(--t2-font);\n     font-size:      32px;\n     font-weight:    800;\n     line-height:    1.2;\n     letter-spacing: -0.5px;\n     margin-bottom:  12px;\n     color:          var(--t2-text);\n   }\n   \n   /* Matches .tdb-header-desc: 16px / 400 / 1.7 / text-muted / max-width 640px */\n   .cre2-hero-desc {\n     font-family: var(--t2-font);\n     font-size:   16px;\n     font-weight: 400;\n     color:       var(--t2-text-muted);\n     max-width:   640px;\n     line-height: 1.7;\n     margin:      0;\n   }\n   \n   .cre2-hero-meta {\n     display:    flex;\n     gap:        24px;\n     margin-top: 20px;\n     flex-wrap:  wrap;\n   }\n   \n   /* Matches tdb meta-item: 12px / 400 / text-dim */\n   .cre2-meta-item {\n     font-family: var(--t2-font);\n     font-size:   12px;\n     font-weight: 400;\n     color:       var(--t2-text-dim);\n     display:     flex;\n     align-items: center;\n     gap:         6px;\n   }\n   \n   .cre2-meta-dot {\n     width:         6px;\n     height:        6px;\n     border-radius: 50%;\n     background:    var(--t2-accent);\n     display:       inline-block;\n     flex-shrink:   0;\n   }\n   \n   /* ─── TOC box ───────────────────────────────────────────────── */\n   .cre2-toc-box {\n     background:    var(--t2-surface);\n     border:        1px solid var(--t2-border);\n     border-left:   3px solid var(--t2-accent);\n     border-radius: var(--t2-radius-md);\n     padding:       22px 26px;\n     margin-bottom: 40px;\n     box-shadow:    0 2px 8px rgba(0, 0, 0, 0.06);\n   }\n   \n   /* Matches tdb-card-tag: 12px / 700 / uppercase / 0.8px tracking / accent */\n   .cre2-toc-box h3 {\n     font-family:    var(--t2-font);\n     font-size:      12px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 0.8px;\n     color:          var(--t2-accent);\n     margin-bottom:  14px;\n   }\n   \n   .cre2-toc-grid {\n     display:               grid;\n     grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n     gap:                   6px 24px;\n   }\n   \n   /* Matches tdb-popup-bullets li: 13px / 400 / blue */\n   .cre2-toc-link {\n     font-family:     var(--t2-font);\n     font-size:       13px;\n     font-weight:     400;\n     color:           var(--t2-blue);\n     text-decoration: none;\n     display:         flex;\n     align-items:     center;\n     padding:         2px 0;\n     transition:      color 0.15s;\n   }\n   .cre2-toc-link:hover { color: var(--t2-accent); }\n   \n   /* ─── Lecture badge — matches .tdb-badge ────────────────────── */\n   /* Matches .tdb-badge: 12px / 700 / uppercase / 0.2px tracking / 3px 9px */\n   .cre2-lec-badge {\n     display:        inline-block;\n     font-family:    var(--t2-font);\n     font-size:      12px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 0.2px;\n     padding:        3px 9px;\n     border-radius:  var(--t2-radius-sm);\n     margin-bottom:  14px;\n   }\n   \n   .cre2-lec-badge--review {\n     background: rgba(180, 105, 14, 0.08);\n     color:      var(--t2-amber);\n     border:     1px solid var(--t2-amber-border);\n   }\n   .cre2-lec-badge--lec2 {\n     background: var(--t2-blue-dim);\n     color:      var(--t2-blue);\n     border:     1px solid var(--t2-blue-border);\n   }\n   \n   /* ─── Section ───────────────────────────────────────────────── */\n   .cre2-section {\n     margin-bottom:     var(--t2-space-2xl);\n     scroll-margin-top: 24px;\n   }\n   \n   /* Matches .tdb-header-tag: 13px / 700 / uppercase / 2px tracking / purple */\n   .cre2-section-label {\n     font-family:    var(--t2-font);\n     font-size:      13px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t2-purple);\n     margin-bottom:  8px;\n   }\n   \n   /* Matches tdb section heading: 26px / 800 / -0.3px / 1.25 lh */\n   .cre2-section h2 {\n     font-family:    var(--t2-font);\n     font-size:      26px;\n     font-weight:    800;\n     letter-spacing: -0.3px;\n     color:          var(--t2-text);\n     margin-bottom:  6px;\n     line-height:    1.25;\n   }\n   \n   .cre2-section-divider {\n     width:         40px;\n     height:        3px;\n     background:    var(--t2-accent);\n     margin-bottom: 22px;\n     border-radius: 2px;\n   }\n   \n   /* Matches .tdb-card-title: 17px / 700 / -0.1px */\n   .cre2-section h3 {\n     font-family:    var(--t2-font);\n     font-size:      17px;\n     font-weight:    700;\n     letter-spacing: -0.1px;\n     color:          var(--t2-text);\n     margin:         28px 0 10px;\n   }\n   \n   /* Matches tdb body copy: 15px / 400 / 1.7 / text-muted */\n   .cre2-section p {\n     font-family:   var(--t2-font);\n     font-size:     15px;\n     font-weight:   400;\n     margin-bottom: 14px;\n     color:         var(--t2-text-muted);\n     line-height:   1.7;\n   }\n   \n   /* Matches tdb-popup-bullets: 14px / 400 / 1.65 / text-muted */\n   .cre2-section ul,\n   .cre2-section ol {\n     font-family:   var(--t2-font);\n     font-size:     14px;\n     font-weight:   400;\n     padding-left:  20px;\n     margin-bottom: 14px;\n     color:         var(--t2-text-muted);\n     line-height:   1.65;\n   }\n   .cre2-section li { margin-bottom: 6px; }\n   \n   /* ─── Equation box ──────────────────────────────────────────── */\n   .cre2-eq-box {\n     background:    var(--t2-eq-bg);\n     border:        1px solid var(--t2-border);\n     border-left:   3px solid var(--t2-amber);\n     border-radius: var(--t2-radius-md);\n     padding:       18px 22px;\n     margin:        18px 0;\n     overflow-x:    auto;\n   }\n   \n   /* Matches tdb-card-tag label: 11px / 700 / uppercase / 0.8px */\n   .cre2-eq-label {\n     font-family:    var(--t2-font);\n     font-size:      11px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 0.8px;\n     color:          var(--t2-text-dim);\n     margin-bottom:  8px;\n   }\n   \n   .cre2-eq-main {\n     font-family: var(--t2-font-mono);\n     font-size:   14px;\n     color:       var(--t2-blue);\n     line-height: 2;\n     white-space: pre-line;\n   }\n   \n   /* Matches tdb-eq-note: 12px / 400 / 1.6 / text-dim */\n   .cre2-eq-note {\n     font-family: var(--t2-font);\n     font-size:   12px;\n     font-weight: 400;\n     color:       var(--t2-text-dim);\n     margin-top:  8px;\n     white-space: pre-line;\n     line-height: 1.6;\n   }\n   \n   /* ─── Callout boxes — matches .tdb-popup-desc ───────────────── */\n   .cre2-callout {\n     border-radius: var(--t2-radius-md);\n     padding:       14px 18px;\n     margin:        18px 0;\n     line-height:   1.65;\n   }\n   /* Matches .tdb-popup-desc: 14px / 400 / 1.65 / text-muted */\n   .cre2-callout p {\n     font-family: var(--t2-font);\n     font-size:   14px;\n     font-weight: 400;\n     color:       var(--t2-text-muted);\n     margin:      0;\n     line-height: 1.65;\n   }\n   .cre2-callout--key  { background: var(--t2-blue-dim);  border: 1px solid var(--t2-blue-border);  }\n   .cre2-callout--warn { background: var(--t2-amber-dim); border: 1px solid var(--t2-amber-border); }\n   .cre2-callout--tip  { background: var(--t2-green-dim); border: 1px solid var(--t2-green-border); }\n   .cre2-callout--info { background: var(--t2-cyan-dim);  border: 1px solid var(--t2-cyan-border);  }\n   \n   /* ─── Card grid ─────────────────────────────────────────────── */\n   .cre2-card-grid {\n     display:               grid;\n     grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n     gap:                   14px;\n     margin:                20px 0;\n   }\n   \n   .cre2-card {\n     background:    var(--t2-surface);\n     border:        1px solid var(--t2-border);\n     border-radius: var(--t2-radius-md);\n     padding:       16px 18px;\n     transition:    border-color 0.18s, box-shadow 0.18s, transform 0.18s;\n     box-shadow:    0 2px 6px rgba(0, 0, 0, 0.06);\n   }\n   .cre2-card:hover {\n     border-color: var(--t2-accent);\n     box-shadow:   0 8px 28px rgba(0, 0, 0, 0.10);\n     transform:    translateY(-2px);\n   }\n   .cre2-card-icon { font-size: 22px; margin-bottom: 8px; }\n   \n   /* Matches .tdb-card-title: 17px / 700 / -0.1px */\n   .cre2-card h4 {\n     font-family:    var(--t2-font);\n     font-size:      17px;\n     font-weight:    700;\n     color:          var(--t2-text);\n     margin-bottom:  6px;\n     letter-spacing: -0.1px;\n   }\n   /* Matches .tdb-card-desc: 14px / 400 / 1.65 / text-muted */\n   .cre2-card p {\n     font-family: var(--t2-font);\n     font-size:   14px;\n     font-weight: 400;\n     color:       var(--t2-text-muted);\n     margin:      0;\n     line-height: 1.65;\n   }\n   \n   /* ─── Steps list ────────────────────────────────────────────── */\n   .cre2-steps { margin: 20px 0; }\n   \n   .cre2-step {\n     display:       flex;\n     gap:           16px;\n     margin-bottom: 20px;\n     align-items:   flex-start;\n   }\n   \n   .cre2-step-num {\n     min-width:       32px;\n     height:          32px;\n     background:      var(--t2-accent);\n     color:           #fff;\n     border-radius:   50%;\n     display:         flex;\n     align-items:     center;\n     justify-content: center;\n     font-family:     var(--t2-font);\n     font-weight:     700;\n     font-size:       13px;\n     margin-top:      2px;\n     flex-shrink:     0;\n     box-shadow:      0 2px 8px var(--t2-accent-glow);\n   }\n   \n   .cre2-step-content { flex: 1; }\n   /* Matches .tdb-card-title: 17px / 700 / -0.1px */\n   .cre2-step-content h4 {\n     font-family:    var(--t2-font);\n     font-size:      17px;\n     font-weight:    700;\n     color:          var(--t2-text);\n     margin-bottom:  6px;\n     letter-spacing: -0.1px;\n   }\n   /* Matches .tdb-card-desc: 14px / 400 / 1.65 */\n   .cre2-step-content p {\n     font-family: var(--t2-font);\n     font-size:   14px;\n     font-weight: 400;\n     color:       var(--t2-text-muted);\n     margin:      0 0 8px;\n     line-height: 1.65;\n   }\n   \n   /* ─── Example box ───────────────────────────────────────────── */\n   .cre2-example-box {\n     background:    var(--t2-surface);\n     border:        1px solid var(--t2-border);\n     border-top:    3px solid var(--t2-accent);\n     border-radius: var(--t2-radius-md);\n     padding:       20px 24px;\n     margin:        20px 0;\n     box-shadow:    0 2px 6px rgba(0, 0, 0, 0.06);\n   }\n   \n   /* Matches .tdb-badge: 12px / 700 / uppercase / 0.2px tracking */\n   .cre2-example-tag {\n     font-family:    var(--t2-font);\n     font-size:      12px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 0.2px;\n     color:          var(--t2-accent);\n     margin-bottom:  8px;\n   }\n   /* Matches .tdb-card-title: 17px / 700 / -0.1px */\n   .cre2-example-box h4 {\n     font-family:    var(--t2-font);\n     font-size:      17px;\n     font-weight:    700;\n     color:          var(--t2-text);\n     margin-bottom:  10px;\n     letter-spacing: -0.1px;\n   }\n   /* Matches .tdb-card-desc: 14px / 400 / 1.65 */\n   .cre2-example-box p {\n     font-family:   var(--t2-font);\n     font-size:     14px;\n     font-weight:   400;\n     color:         var(--t2-text-muted);\n     margin-bottom: 10px;\n     line-height:   1.65;\n   }\n   \n   /* ─── Tables ─────────────────────────────────────────────────── */\n   .cre2-table {\n     width:           100%;\n     border-collapse: collapse;\n     margin:          20px 0;\n     font-family:     var(--t2-font);\n     font-size:       13px;\n     background:      var(--t2-surface);\n     border-radius:   var(--t2-radius-md);\n     overflow:        hidden;\n     border:          1px solid var(--t2-border);\n   }\n   .cre2-table thead { background: var(--t2-panel); }\n   /* Matches tdb-table th: 11px / 700 / uppercase / 0.8px tracking */\n   .cre2-table th {\n     padding:        10px 14px;\n     text-align:     left;\n     font-family:    var(--t2-font);\n     font-size:      11px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 0.8px;\n     color:          var(--t2-text-muted);\n     border-bottom:  1px solid var(--t2-border);\n   }\n   /* Matches tdb-table td: 13px / 400 / 1.55 / text-muted */\n   .cre2-table td {\n     font-family:    var(--t2-font);\n     font-size:      13px;\n     font-weight:    400;\n     padding:        10px 14px;\n     border-bottom:  1px solid var(--t2-border-light);\n     color:          var(--t2-text-muted);\n     vertical-align: top;\n     line-height:    1.55;\n   }\n   .cre2-table tr:last-child td { border-bottom: none; }\n   .cre2-table tr:hover td { background: rgba(40, 167, 69, 0.03); }\n   \n   /* ─── Inline code ───────────────────────────────────────────── */\n   .cre2-inline-code {\n     font-family:   var(--t2-font-mono);\n     font-size:     0.88em;\n     background:    var(--t2-code-bg);\n     color:         var(--t2-blue);\n     padding:       2px 6px;\n     border-radius: var(--t2-radius-sm);\n     border:        1px solid var(--t2-border-light);\n   }\n   \n   /* ─── Reactor type badges — matches .tdb-badge ──────────────── */\n   /* Matches .tdb-badge: 12px / 700 / uppercase / 0.2px tracking */\n   .cre2-badge {\n     display:        inline-block;\n     font-family:    var(--t2-font);\n     font-size:      12px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 0.2px;\n     padding:        3px 9px;\n     border-radius:  var(--t2-radius-sm);\n     white-space:    nowrap;\n   }\n   .cre2-badge--batch { background: rgba(180, 105, 14, 0.08); color: var(--t2-batch); border: 1px solid var(--t2-amber-border); }\n   .cre2-badge--cstr  { background: rgba(192, 57, 43, 0.08);  color: var(--t2-cstr);  border: 1px solid rgba(192, 57, 43, 0.18); }\n   .cre2-badge--pfr   { background: var(--t2-blue-dim);        color: var(--t2-pfr);   border: 1px solid var(--t2-blue-border); }\n   .cre2-badge--pbr   { background: var(--t2-green-dim);       color: var(--t2-pbr);   border: 1px solid var(--t2-green-border); }\n   \n   /* ─── Reactor block (colored card per reactor type) ─────────── */\n   .cre2-reactor-block {\n     border-radius: var(--t2-radius-md);\n     overflow:      hidden;\n     margin:        20px 0;\n     border:        1px solid var(--t2-border);\n     box-shadow:    0 2px 6px rgba(0, 0, 0, 0.06);\n   }\n   \n   /* Matches tdb-badge label: 11px / 700 / uppercase / 1.5px tracking */\n   .cre2-reactor-block-header {\n     padding:        10px 18px;\n     font-family:    var(--t2-font);\n     font-size:      11px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 1.5px;\n   }\n   .cre2-reactor-block-body {\n     padding:    18px 20px;\n     background: var(--t2-surface);\n   }\n   .cre2-reactor-block-body > .cre2-eq-box:first-child { margin-top: 0; }\n   \n   .cre2-reactor-block--batch .cre2-reactor-block-header {\n     background:    rgba(180, 105, 14, 0.08);\n     color:         var(--t2-batch);\n     border-bottom: 1px solid var(--t2-amber-border);\n   }\n   .cre2-reactor-block--cstr .cre2-reactor-block-header {\n     background:    rgba(192, 57, 43, 0.08);\n     color:         var(--t2-cstr);\n     border-bottom: 1px solid rgba(192, 57, 43, 0.18);\n   }\n   .cre2-reactor-block--pfr .cre2-reactor-block-header {\n     background:    var(--t2-blue-dim);\n     color:         var(--t2-pfr);\n     border-bottom: 1px solid var(--t2-blue-border);\n   }\n   .cre2-reactor-block--pbr .cre2-reactor-block-header {\n     background:    var(--t2-green-dim);\n     color:         var(--t2-pbr);\n     border-bottom: 1px solid var(--t2-green-border);\n   }\n   \n   /* ─── Levenspiel plot container ─────────────────────────────── */\n   .cre2-levenspiel-container {\n     background:    var(--t2-surface);\n     border:        1px solid var(--t2-border);\n     border-radius: var(--t2-radius-md);\n     padding:       24px;\n     margin:        24px 0;\n     box-shadow:    0 2px 8px rgba(0, 0, 0, 0.06);\n   }\n   \n   /* Matches tdb-card-tag: 12px / 700 / uppercase / 0.8px tracking */\n   .cre2-levenspiel-title {\n     font-family:    var(--t2-font);\n     font-size:      12px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 0.8px;\n     color:          var(--t2-text-dim);\n     margin-bottom:  16px;\n   }\n   \n   .cre2-levenspiel-svg {\n     width:         100%;\n     max-width:     520px;\n     display:       block;\n     margin:        0 auto;\n     border-radius: var(--t2-radius-sm);\n   }\n   \n   /* Matches tdb-footer / diagram-caption: 12px / 400 / text-dim */\n   .cre2-levenspiel-caption {\n     font-family: var(--t2-font);\n     font-size:   12px;\n     font-weight: 400;\n     color:       var(--t2-text-sub);\n     text-align:  center;\n     margin-top:  14px;\n     font-style:  italic;\n     line-height: 1.5;\n   }\n   \n   /* ─── Reactors in Series diagram ────────────────────────────── */\n   .cre2-series-diagram {\n     display:       flex;\n     align-items:   center;\n     gap:           8px;\n     flex-wrap:     wrap;\n     margin:        24px 0;\n     padding:       20px;\n     background:    var(--t2-surface);\n     border:        1px solid var(--t2-border);\n     border-radius: var(--t2-radius-md);\n   }\n   \n   .cre2-series-reactor {\n     display:         flex;\n     flex-direction:  column;\n     align-items:     center;\n     justify-content: center;\n     width:           90px;\n     height:          90px;\n     border-radius:   var(--t2-radius-md);\n     border:          2px solid;\n     padding:         10px;\n     text-align:      center;\n     flex-shrink:     0;\n   }\n   \n   .cre2-series-reactor--cstr {\n     background:   rgba(192, 57, 43, 0.08);\n     border-color: rgba(192, 57, 43, 0.35);\n   }\n   .cre2-series-reactor--pfr {\n     background:     var(--t2-blue-dim);\n     border-color:   rgba(37, 99, 235, 0.35);\n     border-radius:  40px;\n   }\n   \n   /* Matches tdb-card-tag: 12px / 700 / uppercase */\n   .cre2-series-label {\n     font-family:    var(--t2-font);\n     font-size:      11px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 0.8px;\n   }\n   .cre2-series-reactor--cstr .cre2-series-label { color: var(--t2-cstr); }\n   .cre2-series-reactor--pfr  .cre2-series-label { color: var(--t2-pfr); }\n   \n   /* Matches tdb body values: 13px / 700 / text-mid */\n   .cre2-series-vol {\n     font-family: var(--t2-font);\n     font-size:   13px;\n     font-weight: 700;\n     color:       var(--t2-text-mid);\n     margin:      4px 0 2px;\n   }\n   /* Matches caption / dim text: 12px / 400 */\n   .cre2-series-rate {\n     font-family: var(--t2-font);\n     font-size:   12px;\n     font-weight: 400;\n     color:       var(--t2-text-sub);\n   }\n   \n   .cre2-series-arrow {\n     display:        flex;\n     flex-direction: column;\n     align-items:    center;\n     gap:            4px;\n     flex-shrink:    0;\n   }\n   /* Matches meta-item: 12px / 400 / accent */\n   .cre2-series-arrow span {\n     font-family: var(--t2-font);\n     font-size:   12px;\n     font-weight: 400;\n     color:       var(--t2-accent);\n     white-space: nowrap;\n   }\n   .cre2-arrow-line {\n     font-size:   20px;\n     color:       var(--t2-text-sub);\n     line-height: 1;\n   }\n   \n   /* ─── Tower (CRE Algorithm) ─────────────────────────────────── */\n   .cre2-tower {\n     margin:         20px 0;\n     display:        flex;\n     flex-direction: column;\n     gap:            0;\n   }\n   \n   .cre2-tower-level {\n     display:     flex;\n     gap:         16px;\n     padding:     16px 20px;\n     border:      1px solid var(--t2-border-light);\n     border-bottom: none;\n     align-items: flex-start;\n     transition:  background 0.15s;\n   }\n   .cre2-tower-level:first-child { border-radius: var(--t2-radius-md) var(--t2-radius-md) 0 0; }\n   .cre2-tower-level:last-child  { border-bottom: 1px solid var(--t2-border-light); border-radius: 0 0 var(--t2-radius-md) var(--t2-radius-md); }\n   .cre2-tower-level:hover       { background: rgba(40, 167, 69, 0.03); }\n   \n   .cre2-tower-level--1 { background: rgba(40, 167, 69, 0.05); }\n   .cre2-tower-level--2 { background: rgba(37, 99, 235, 0.05); }\n   .cre2-tower-level--3 { background: rgba(180, 105, 14, 0.05); }\n   .cre2-tower-level--4 { background: rgba(8, 145, 178, 0.05); }\n   .cre2-tower-level--5 { background: rgba(192, 57, 43, 0.05); }\n   \n   .cre2-tower-num {\n     min-width:       32px;\n     height:          32px;\n     border-radius:   50%;\n     display:         flex;\n     align-items:     center;\n     justify-content: center;\n     font-family:     var(--t2-font);\n     font-weight:     700;\n     font-size:       13px;\n     color:           #fff;\n     flex-shrink:     0;\n     box-shadow:      0 2px 8px var(--t2-accent-glow);\n   }\n   .cre2-tower-level--1 .cre2-tower-num { background: var(--t2-accent); }\n   .cre2-tower-level--2 .cre2-tower-num { background: var(--t2-pfr); }\n   .cre2-tower-level--3 .cre2-tower-num { background: var(--t2-amber); }\n   .cre2-tower-level--4 .cre2-tower-num { background: var(--t2-cyan); }\n   .cre2-tower-level--5 .cre2-tower-num { background: var(--t2-cstr); }\n   \n   .cre2-tower-content { flex: 1; }\n   /* Matches .tdb-card-title: 17px / 700 / -0.1px */\n   .cre2-tower-content h4 {\n     font-family:    var(--t2-font);\n     font-size:      17px;\n     font-weight:    700;\n     color:          var(--t2-text);\n     margin-bottom:  4px;\n     letter-spacing: -0.1px;\n   }\n   /* Matches .tdb-card-desc: 14px / 400 / 1.65 */\n   .cre2-tower-content p {\n     font-family: var(--t2-font);\n     font-size:   14px;\n     font-weight: 400;\n     color:       var(--t2-text-muted);\n     margin:      0;\n     line-height: 1.65;\n   }\n   \n   /* ─── Images ────────────────────────────────────────────────── */\n   img {\n     max-width: 100%;\n     height: auto;\n     display: block;\n     margin: 20px auto;\n     border-radius: var(--t2-radius-md);\n     box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n     transition: transform 0.2s ease, box-shadow 0.2s ease;\n     border: 1px solid var(--t2-border-light);\n   }\n   img:hover {\n     transform: translateY(-2px);\n     box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);\n   }\n   .cre2-section img { margin: 20px auto; max-width: 90%; }\n   \n   /* ─── Footer — matches Tutorial1 cre-footer ────────────────── */\n   /* Matches tdb footer: 12px / 400 / text-dim */\n   .cre2-footer {\n     border-top:  1px solid var(--t2-border-light);\n     padding-top: 24px;\n     margin-top:  40px;\n     font-family: var(--t2-font);\n     font-size:   12px;\n     font-weight: 400;\n     color:       var(--t2-text-dim);\n     line-height: 1.6;\n   }\n   \n   /* ─── Animation ─────────────────────────────────────────────── */\n   @keyframes fadeIn2 {\n     from { opacity: 0; transform: translateY(8px); }\n     to   { opacity: 1; transform: translateY(0); }\n   }\n   \n   /* ─── Responsive ────────────────────────────────────────────── */\n   @media (max-width: 1200px) {\n     .cre2-main-inner { padding: 40px 40px 64px; }\n   }\n   \n   @media (max-width: 900px) {\n     .cre2-sidebar { display: none !important; }\n     .cre2-main-inner     { padding: 28px 20px 52px; max-width: 100%; }\n     .cre2-toc-grid       { grid-template-columns: 1fr 1fr; }\n     .cre2-series-diagram { gap: 6px; }\n     .cre2-hero h1        { font-size: 26px; }\n     .cre2-hero-desc      { font-size: 15px; }\n   }\n   \n   @media (max-width: 600px) {\n     .cre2-card-grid        { grid-template-columns: 1fr; }\n     .cre2-toc-grid         { grid-template-columns: 1fr; }\n     .cre2-series-diagram   { flex-direction: column; align-items: flex-start; }\n     .cre2-arrow-line       { transform: rotate(90deg); }\n   }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
